import { Link } from "react-router-dom";
import { Phone, Mail, MapPin } from "lucide-react";

const LOGO_URL = "https://customer-assets.emergentagent.com/job_82f7828c-c7a0-48a6-b1cb-fc4aadec5e5f/artifacts/4dy14776_Order%20%26%20Clean%20Co-%20Main%20Logo.jpeg";

const Footer = () => {
  return (
    <footer className="bg-[#0A0A0A] text-white">
      <div className="max-w-7xl mx-auto px-6 md:px-12 py-16">
        <div className="grid grid-cols-1 md:grid-cols-4 gap-12">
          {/* Brand */}
          <div className="md:col-span-2">
            <div className="flex items-center gap-3 mb-6">
              <img 
                src={LOGO_URL} 
                alt="Order & Clean Co." 
                className="h-16 w-16 object-contain rounded-full"
              />
              <div>
                <h3 className="font-bold text-xl tracking-tight" style={{ fontFamily: 'Barlow Condensed, sans-serif' }}>
                  ORDER & CLEAN CO
                </h3>
                <p className="text-slate-400 text-sm">Organise. Clean. Reset.</p>
              </div>
            </div>
            <p className="text-slate-400 leading-relaxed max-w-md">
              Transform your garage in a single day. Professional cleanouts, organisation, 
              and space enhancement services for Sydney homes. Old-school quality, done right.
            </p>
          </div>

          {/* Quick Links */}
          <div>
            <h4 className="font-bold uppercase tracking-widest text-sm mb-6" style={{ fontFamily: 'Barlow Condensed, sans-serif' }}>
              Quick Links
            </h4>
            <ul className="space-y-3">
              <li>
                <Link to="/services" className="text-slate-400 hover:text-white transition-colors">
                  Our Services
                </Link>
              </li>
              <li>
                <Link to="/enhancements" className="text-slate-400 hover:text-white transition-colors">
                  Space Upgrades
                </Link>
              </li>
              <li>
                <Link to="/booking" className="text-slate-400 hover:text-white transition-colors">
                  Book Now
                </Link>
              </li>
            </ul>
          </div>

          {/* Contact */}
          <div>
            <h4 className="font-bold uppercase tracking-widest text-sm mb-6" style={{ fontFamily: 'Barlow Condensed, sans-serif' }}>
              Contact
            </h4>
            <ul className="space-y-3">
              <li className="flex items-center gap-3 text-slate-400">
                <Phone size={16} />
                <span>0457 289 168</span>
              </li>
              <li className="flex items-center gap-3 text-slate-400">
                <Mail size={16} />
                <span>hello@orderandcleanco.com.au</span>
              </li>
              <li className="flex items-start gap-3 text-slate-400">
                <MapPin size={16} className="mt-1 flex-shrink-0" />
                <span>Sydney & Surrounding Regions<br />NSW, Australia</span>
              </li>
            </ul>
          </div>
        </div>

        <div className="border-t border-slate-800 mt-12 pt-8 flex flex-col md:flex-row justify-between items-center gap-4">
          <p className="text-slate-500 text-sm">
            &copy; {new Date().getFullYear()} Order & Clean Co. All rights reserved.
          </p>
          <div className="flex gap-6">
            <Link to="/privacy" className="text-slate-500 hover:text-white text-sm transition-colors" data-testid="footer-privacy-link">
              Privacy Policy
            </Link>
            <Link to="/terms" className="text-slate-500 hover:text-white text-sm transition-colors" data-testid="footer-terms-link">
              Terms of Service
            </Link>
          </div>
        </div>
      </div>
    </footer>
  );
};

export default Footer;
